<div class="row no-gutters mt-3 justify-content-end">
  <div class="col">
    <h5 *ngIf="sharedData.getSelectedUser().id === getUserId()">
      {{sharedData.getSelectedUser().username}}
      <small *ngIf="sharedData.getSelectedUser() && sharedData.getSelectedUser().email" class="text-muted">
        ({{sharedData.getSelectedUser().email}})
      </small>
    </h5>
  </div>
</div>
<router-outlet></router-outlet>
